// Catalog asset IDs may be a plain uid:
//   af3v-3kxc
// or a uid with a revision ID:
//   af3v-3kxc:2
//
// These helpers provide ways to get either component.

export const coreUidFromAssetId = (catalogId) => catalogId ? catalogId.slice(0, 9) : catalogId;
export const revisionSeqFromCatalogId = (catalogId) => (catalogId || '').split(':')[1];
